import React from 'react';
import './App.css';
import { Admin, Resource } from 'react-admin';
import { AppAuthProvider, AppDataProvider } from './providers';
import { UserRole } from './interfaces';
import {
    SeasonsList,
    SeasonOrganizationsList,
    SeasonOrganizationSettings,
    RegistrantList,
    RegistrantsShow,
    VisitsList,
    UsersList,
    UserCreate,
    UserEdit,
    CouponsList,
} from './resources';

const App = () => {
    return (
        <Admin dataProvider={AppDataProvider} authProvider={AppAuthProvider}>
            {(permissions) => [
                <Resource key="season" name="season" list={SeasonsList} />,
                <Resource
                    key="season-organization"
                    name="season-organization"
                    list={SeasonOrganizationsList}
                    edit={SeasonOrganizationSettings}
                />,
                <Resource
                    key="registrant"
                    name="registrant"
                    list={RegistrantList}
                    show={RegistrantsShow}
                />,
                <Resource
                    key="coupon"
                    name="coupon"
                    list={CouponsList}
                    options={{ label: 'Coupons' }}
                />,
                <Resource key="visit" name="visit" list={VisitsList} />,
                <Resource key="participant" name="participant" />,
                <Resource key="notification" name="notification" />,
                ...(permissions === UserRole.SUPER_ADMIN
                    ? [
                          <Resource
                              key="user"
                              name="user"
                              list={UsersList}
                              create={UserCreate}
                              edit={UserEdit}
                          />,
                      ]
                    : []),
                // <Resource key="features" name="features" />,
            ]}
        </Admin>
    );
};

export default App;
